import React from "react";
import Card from "./card";

export const AddEditForm = (props) => {
  return <Card {...props} />;
};
